import React from "react";
import { publicLinkConstants } from "../constants";
import { PublicPageRoute } from "../routes/PublicPage.route";
import { AddQuestionPageContent } from "./AddQuestionPage";
import { ListQuestionsPageContent } from "./ListQuestionsPageContent";
import { QuestionDetailPage } from "./QuestionDetailPage";
import { UpdateQuestionPageContent } from "./UpdateQuestionPageContent";
import { CompanyQuestionListPageContent } from "./CompanyQuestion.List.PageContent";
import { QuestionConstants } from "./Question.Constants";

export function QuestionRoutes() {
  return (
    <>
      <PublicPageRoute
        path={QuestionConstants.PAGE_QUESTIONS_LIST}
        contentComponent={ListQuestionsPageContent}
      />
      <PublicPageRoute
        path={QuestionConstants.PAGE_QUESTION_DETAILS}
        contentComponent={QuestionDetailPage}
      />
      <PublicPageRoute
        exact
        path={QuestionConstants.PAGE_QUESTION_ADD}
        contentComponent={AddQuestionPageContent}
      />
      <PublicPageRoute
        exact
        path={QuestionConstants.PAGE_QUESTION_EDIT}
        contentComponent={UpdateQuestionPageContent}
      />
      <PublicPageRoute
        exact
        path={QuestionConstants.PAGE_COMPANY_QUESTIONS}
        contentComponent={CompanyQuestionListPageContent}
      />
    </>
  );
}
